import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import type { BeneficiaryFormSchema } from '../../schemas/beneficiarySchema';
import { beneficiarySchema } from '../../schemas/beneficiarySchema';
import { useState } from 'react';
import type { ReactElement, SetStateAction } from 'react';

export default function FormBeneficiary(): ReactElement {
  const [selecionado, setSelecionado] = useState('');

  const handleChange = (valor: SetStateAction<string>) => {
    setSelecionado(valor === selecionado ? '' : valor);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<BeneficiaryFormSchema>({
    resolver: zodResolver(beneficiarySchema),
  });

  const [excelFile, setExcelFile] = useState<File | null>(null);

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      setExcelFile(e.target.files[0]);
    }
  }

  async function onSubmit(data: BeneficiaryFormSchema) {
    console.log('Dados do formulário:', data);
    if (!excelFile) {
      alert('Por favor, envie uma planilha Excel.');
      return;
    }

    const formData = new FormData();

    formData.append('formData', JSON.stringify(data));

    formData.append('file', excelFile);

    try {
      const response = await fetch('/api/upload', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Erro no upload');
      }

      alert('Upload e envio feitos com sucesso!');
    } catch (error) {
      alert('Erro: ' + error);
    }
  }

  return (
    <div className=" mb-5 p-5">
      <div className="p-10">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="max-w-3xl mx-auto p-8 mb-10 mt-10 rounded-xl shadow-lg grid gap-8"
        >
          <h2 className="text-3xl font-extrabold text-blue-900 tracking-wide mb-2 text-center"></h2>

          <div className="w-50 relative flex gap-2">
            <label
              htmlFor="checkbox1"
              className="relative h-6 w-6 flex items-center justify-center overflow-hidden rounded-full bg-gradient-to-tr from-[#4158D0] via-[#131446] to-[#ffcd7065] p-1 duration-100 hover:p-1.5 cursor-pointer"
            >
              <input
                type="checkbox"
                className="peer hidden"
                id="checkbox1"
                checked={selecionado === 'empressarial'}
                onChange={() => handleChange('empressarial')}
              />
              <div className="absolute left-[0.47rem] h-[3px] w-[14px] -translate-y-8 translate-x-8 rotate-[-71deg] rounded-sm bg-white duration-300 peer-checked:translate-x-0 peer-checked:translate-y-0"></div>
              <div className="absolute left-1 top-[0.87rem] h-[3px] w-[10px] -translate-x-8 -translate-y-8 rotate-[25deg] rounded-sm bg-white duration-300 peer-checked:translate-x-0 peer-checked:translate-y-0"></div>
            </label>
            <span>Empressarial</span>
          </div>

          <div className="w-50 relative flex gap-2">
            <label
              htmlFor="checkbox2"
              className="relative h-6 w-6 flex items-center justify-center overflow-hidden rounded-full bg-gradient-to-tr from-[#4158D0] via-[#131446] to-[#ffcd7065] p-1 duration-100 hover:p-1.5 cursor-pointer"
            >
              <input
                type="checkbox"
                className="peer hidden"
                id="checkbox2"
                checked={selecionado === 'administradora'}
                onChange={() => handleChange('administradora')}
              />
              <div className="absolute left-[0.47rem] h-[3px] w-[14px] -translate-y-8 translate-x-8 rotate-[-71deg] rounded-sm bg-white duration-300 peer-checked:translate-x-0 peer-checked:translate-y-0"></div>
              <div className="absolute left-1 top-[0.87rem] h-[3px] w-[10px] -translate-x-8 -translate-y-8 rotate-[25deg] rounded-sm bg-white duration-300 peer-checked:translate-x-0 peer-checked:translate-y-0"></div>
            </label>
            <span>Administradora</span>
          </div>

          <div className="flex flex-col">
            <label
              htmlFor="excelFile"
              className="mb-2 font-semibold text-blue-800"
            >
              Upload da Planilha Excel
            </label>
            <input
              id="excelFile"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="w-full px-4 py-2 border border-blue-300 rounded-lg bg-blue-50 text-blue-900 font-medium
                focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-600 transition"
            />
          </div>

          <button
            type="submit"
            className="w-full py-4 bg-gradient-to-r from-blue-600 to-blue-900 text-white font-extrabold rounded-xl shadow-lg
                 hover:from-blue-700 hover:to-blue-800 transition"
          >
            Enviar
          </button>
        </form>
      </div>
    </div>
  );
}
